export default __webpack_public_path__ + "static/media/QK_8934.3ce73c8c.jpg";